import { Controller } from "@hotwired/stimulus"

// Caps an opened dropdown panel at the space left below it, so its last entries and footer
// stay reachable (the panel scrolls). Where the trigger sits depends on how far the toolbar
// wraps, so a fixed `max-h-[calc(100dvh-…)]` guess runs off short or narrow screens. The
// class stays as the fallback until the first open.
//
//   <div data-controller="dropdown viewport-fit">
//     <button data-action="click->dropdown#toggle click->viewport-fit#fit">
//     <div data-dropdown-target="menu" data-viewport-fit-target="panel">
export default class extends Controller {
  static targets = ["panel"]
  static values = { margin: { type: Number, default: 16 } }

  fit() {
    if (!this.hasPanelTarget || this.panelTarget.classList.contains("hidden")) return

    const top = this.panelTarget.getBoundingClientRect().top
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight
    this.panelTarget.style.maxHeight = `${Math.max(viewportHeight - top - this.marginValue, 0)}px`
  }
}
